<pr-form
  (onSubmit)="onSubmit()"
  [title]="title"
  [formGroup]="form"
  clazz="drawer-form"
  [formWithTabs]="true"
  (nextTab)="nextTab()"
  [tabChanged]="tabChanged"
>
  <button top-right-action class="btn-nostyle" type="button">
    <pr-icon
      name="sp-close"
      viewBoxHeight="23"
      viewBoxWidth="23"
      (click)="prFormService.close()"
    ></pr-icon>
  </button>

  <pr-tabs
    clazz="drawer-tab-button"
    [defaultTextColor]="false"
    [changeTab]="changeTab"
    (lastTab)="onTabChange($event)"
  >
    <pr-tab label="Informations générales">
      <h3 class="drawer-title">Informations du bien</h3>
      <div class="form-sct-container">
        <input formControlName="id" type="hidden" />

        <pr-input [label]="'Label'" [derrors]="derrors">
          <input formControlName="label" type="text" />
        </pr-input>

        <pr-input label="Catégorie" [derrors]="derrors">
          <mat-select formControlName="personalUseType">
            @for (item of personalUseType; track item) {
              <mat-option [value]="item.id">
                {{ item.value | translate }}
              </mat-option>
            }
          </mat-select>
        </pr-input>

        <pr-input label="Type de détention" [derrors]="derrors">
          <mat-select formControlName="ownershipType">
            @for (item of realEstateOwnershipTypes; track item) {
              <mat-option [value]="item.id">
                {{ item.value | translate }}
              </mat-option>
            }
          </mat-select>
        </pr-input>

        <pr-input [label]="'Prix d\'achat'" [derrors]="derrors" suffix="€"
          ><input formControlName="purchasePrice" type="text"
        /></pr-input>

        <pr-input-date
          formControlName="startDate"
          label="Date d'achat"
          [derrors]="derrors"
        ></pr-input-date>

        <pr-input [label]="'Surface habitable'" [derrors]="derrors" suffix="m²"
          ><input formControlName="areaSize" type="text" />
        </pr-input>

        <pr-input-maps
          (placeChanged)="toValue = $event"
          placeholder="Enter to address..."
          label="Adresse du bien"
          formGroupName="address"
          [isGMaps]="true"
          [countries]="countries"
          [derrors]="derrors"
        ></pr-input-maps>

        <ea-estate-loan-form
          [entity]="entity"
          [derrors]="derrors"
        ></ea-estate-loan-form>
      </div>
    </pr-tab>
    <pr-tab label="Loyers">
      <h3 class="drawer-title">Loyers perçus</h3>
      <div class="form-sct-container">
        <ea-rent-form-personal-use
          [entity]="entity"
          [derrors]="derrors"
        ></ea-rent-form-personal-use>
      </div>
    </pr-tab>
    <pr-tab label="Valorisations">
      <h3 class="drawer-title">Valorisations</h3>
      <div class="form-sct-container">
        <ea-estimation-form
          [entity]="entity"
          [derrors]="derrors"
        ></ea-estimation-form>
      </div>
    </pr-tab>
    <pr-tab label="Charges">
      <h3 class="drawer-title">Charges</h3>
      <div class="form-sct-container">
        <ea-fees-form [entity]="entity" [derrors]="derrors"></ea-fees-form>
      </div>
    </pr-tab>
    <pr-tab label="Détention">
      <h3 class="drawer-title">Informations sur la détention</h3>
      <div class="form-sct-container">
        <pr-input
          label="Type de résidence"
          [derrors]="derrors"
          [hidden]="
            form &&
            ['LAND', 'SURFACE', 'GARAGE'].includes(
              form.get('personalUseType').value
            )
          "
        >
          <mat-select formControlName="residenceType">
            <mat-option value="APPARTMENT">{{
              'pages.realEstate.appartment' | translate
            }}</mat-option>
            <mat-option value="HOUSE">{{
              'pages.realEstate.house' | translate
            }}</mat-option>
          </mat-select>
        </pr-input>

        <pr-input label="Acquis au travers de" [derrors]="derrors">
          <mat-select formControlName="subscriptionSource">
            @for (item of subscriptionSource; track item) {
              <mat-option [value]="item.id">
                {{ item.value | translate }}
              </mat-option>
            }
          </mat-select>
        </pr-input>

        <pr-input-owner-share
          formControlName="owners"
          [derrors]="derrors"
        ></pr-input-owner-share>
      </div>
    </pr-tab>
  </pr-tabs>
</pr-form>
